import { cn } from "@/lib/utils";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const SolutionCard = ({ solution, onOpen }) => {
  const {
    title,
    description,
    bullets,
    image,
    status,
    disabled,
    ctaLabel,
    ctaVariant,
  } = solution;
  const statusDotClass =
    status === "under_construction" ? "bg-amber-500" : "bg-emerald-500";

  return (
    <Card className="flex h-full flex-col gap-3 overflow-hidden py-4 gap-y-3">
      <CardHeader className="px-4 pb-0 min-h-[46px]">
        <CardTitle className="text-sm font-semibold text-foreground line-clamp-2">
          {title}
        </CardTitle>
        {description && (!bullets || bullets.length === 0) ? (
          <p className="text-xs leading-relaxed text-muted-foreground">
            {description}
          </p>
        ) : null}
      </CardHeader>
      <CardContent className="flex flex-1 flex-col gap-4 px-4 pb-0">
        <div className="overflow-hidden rounded-radius border border-border/60 bg-muted/20">
          <img
            src={image}
            alt={`${title} preview`}
            className="h-36 w-full object-cover object-top"
            loading="lazy"
            onError={(event) => {
              event.currentTarget.onerror = null;
              event.currentTarget.src = "/logos/logo.svg";
            }}
          />
        </div>
        {Array.isArray(bullets) && bullets.length > 0 ? (
          <div className="space-y-2 text-xs text-muted-foreground">
            {bullets.map((bullet) => (
              <div key={bullet} className="flex items-start gap-2">
                <span
                  className={cn(
                    "mt-1 h-2 w-2 flex-none rounded-full",
                    statusDotClass,
                  )}
                />
                <span>{bullet}</span>
              </div>
            ))}
          </div>
        ) : null}
      </CardContent>
      <div className="px-4">
        <Button
          type="button"
          className="w-full"
          variant={ctaVariant}
          disabled={disabled}
          onClick={() => onOpen?.(solution)}
        >
          {ctaLabel}
        </Button>
      </div>
    </Card>
  );
};

export default SolutionCard;
